// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"845ee245","237":"d34c0d2e","350":"400e44f8","435":"83fa3690","845":"cc4d3119"}[chunkId] + ".chunk.js";
};